import axiosInstance from "./AxiosInstance";
import phpAxoisInstance from "./PhpAxoisInstance";
import customerAxiosInstance from "./CustomerAxiosInstance";

export function getCountryList() {
    return axiosInstance.get(`country-list`);
}

export function uploadMyFiles(data, onUploadProgress) {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    };

    return axiosInstance.post(`manage/myfiles/upload`, data, config);
}

export function uploadAndClassifyMyFiles(data, onUploadProgress) {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    };

    return axiosInstance.post(`manage/myfiles/classify`, data, config);
}

export function renameSleeveFolder(data) {
    return axiosInstance.post(`envelope/rename-folder`, data);
}

export function addFilesKeywords(data) {
    return axiosInstance.post(`manage/myfiles/add-keyword`, data)
}

export function myFilesGenerateSummary(data) {
    return axiosInstance.post(`manage/myfiles/generate-summary`, data)
}

export function sherMyFiles(data) {
    return axiosInstance.post(`manage/myfiles/share`, data);
}

export function searchKeywordMyfiles(data) {
    return axiosInstance.get(`/manage/myfiles/search-keyword`, { params: data });
}

export function myFilesDetailsForm(data) {
    return axiosInstance.post(`manage/myfiles/detail-form`, data)
}

export function myFilesPreviewDetailsForm(data) {
    return axiosInstance.post(`manage/myfiles/preview-detail-form`, data)
}

export function myFilesFolderCreate(data) {
    return axiosInstance.post(`manage/myfiles/folder/create`, data)
}

export function myFilesReminders(data) {
    return axiosInstance.post(`manage/myfiles/reminders`, data)
}

export function myFilesRemindersDelete(data) {
    return axiosInstance.post(`manage/myfiles/delete-reminder`, data)
}

export function myFilesFolderView(data) {
    return axiosInstance.post(`manage/myfiles/list`, data)
}

export function myFilesFolderDelete(data) {
    return axiosInstance.post(`manage/myfiles/folder/delete`, data)
}

export function myFilesFolderRename(data) {
    return axiosInstance.post(`manage/myfiles/folder/rename`, data)
}

export function myFilesFolderList(data) {
    return axiosInstance.post(`manage/myfiles/folder/list`, data)
}

export function myFilesFolderMove(data) {
    return axiosInstance.post(`manage/myfiles/folder/move`, data)
}

export function deleteMyFiles(data) {
    return axiosInstance.post(`manage/myfiles/delete`, data);
}

export function deleteFilesKeywords(data) {
    return axiosInstance.post(`manage/myfiles/delete-keyword`, data);
}

export function myFilesToggleFavorite(data) {
    return axiosInstance.post(`manage/myfiles/favorite`, data);
}

export function searchKeyword(data) {
    return axiosInstance.get(`search-keyword`, {
        params: data
    });
}

export const addkeyword = (data) => {
    return axiosInstance.post('add-keyword', data);
};


export const generatesummary = (data) => {
    return axiosInstance.post(`generate-summary`, data)
}

export function deletekeyword(data) {
    return axiosInstance.post(`delete-keyword`, data);
}

export function getDocuments(params) {
    return axiosInstance.post('get-documents', params);
}

export function getFaqList() {
    return axiosInstance.get(`faq-list`);
}

export function manageFiles(data) {
    return axiosInstance.post(`envelope/files`, data)
}

export function getCountryByOrder(column) {
    return axiosInstance.get(`country-list?order=` + column);
}

export function getEnvelopeSenderList() {
    return axiosInstance.post(`envelope/sender-list`);
}

export function createEnvelope(data) {
    return axiosInstance.post(`envelope/create`, data);
}

export function updateEnvelope(data) {
    return axiosInstance.post(`envelope/update`, data);
}

export function updateEnvelopeRecipientStep(data) {
    return axiosInstance.post(`envelope/email-detail/update`, data);
}

export function searchEnvelopeRecipient(data) {
    return axiosInstance.post(`envelope/recipient/search`, data);
}

export function createEnvelopeRecipient(data) {
    return axiosInstance.post(`envelope/recipient/create`, data);
}

export function updateRecipient(data) {
    return axiosInstance.post(`recipient/edit`, data);
}


export function recipientimport(formData) {
    let config = {
        headers: {
            "content-Type": "multipart/form-data",
        },
    };

    return axiosInstance.post(`recipient/import`, formData, config);
}


export function modifyEnvelopeDocument(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        },
    };
    return axiosInstance.post(`envelope/documents`, data, config);
}

export function modifyEnvelopeSignDocument(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        },
    };
    return axiosInstance.post(`envelope/sign-documents`, data, config);
}

export function signPlaceholdersUpdate(data) {
    return axiosInstance.post(`envelope/sign-placeholders-update`, data);
}



export function modifyEnvelopeRequestForm(data) {
    return axiosInstance.post(`envelope/request-form`, data);
}

export function modifyEnvelopeRequestInformation(data) {
    return axiosInstance.post(`envelope/request-information`, data);
}
export function modifyEnvelopeSmartQeustionForm(data) {
    return axiosInstance.post(`envelope/smart-request-information`, data);
}

export function modifyDocumentRequestFormOrders(data) {
    return axiosInstance.post(`envelope/set-document-request-form`, data);
}

export function getEnvelopeDocumentDetail(data) {
    return axiosInstance.post(`document-detail`, data);
}

export function getEnvelopeDocumentCheckStorage(data) {
    return axiosInstance.post(`envelope/check-storage`, data);
}

export function removeEnvelopeDocument(data) {
    return axiosInstance.post(`document-delete`, data);
}

export function getEnvelopeRequestFormDetail(data) {
    return axiosInstance.post(`envelope/request-form-detail`, data);
}

export function getEnvelopeRequestInformationDetail(data) {
    return axiosInstance.post(`envelope/request-information-detail`, data);
}

export function getEnvelopeRequestSignDocumentPages(data) {
    return axiosInstance.post(`envelope/sign-document-pages`, data);
}

export function removeEnvelopeRequestForm(data) {
    return axiosInstance.post(`envelope/request-form-delete`, data);
}

export function removeEnvelopeSignDocument(data) {
    return axiosInstance.post(`envelope/sign-document-delete`, data);
}

export function envelopeFinish(data) {
    return axiosInstance.post(`envelope/finish`, data);
}

export function addTemplate(data) {
    return axiosInstance.post(`envelope/add-template`, data);
}

export function changePassword(data) {
    return axiosInstance.post(`change-password`, data);
}

export function updateUserData(data) {
    return axiosInstance.post(`update-user-profile`, data);
}

export function getCompanyDetails(data) {
    return axiosInstance.post(`company-detail`, data);
}

export function updateCompanyDetails(data) {
    return axiosInstance.post(`modify-company`, data);
}

export function getCustomerEnvelopeData(data) {
    return customerAxiosInstance.post(`customer-envelope/detail`, data);
}

export function getCustomerMessageList(data) {
    return axiosInstance.post(`message-list`, data);
}

export function sendCustomerMessage(data) {
    return axiosInstance.post(`message-send`, data);
}

export function recipientSendMessage(data) {
    return customerAxiosInstance.post(`message-send`, data);
}

export function uploadCustomerEnvelopeDocument(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        },
    };
    return customerAxiosInstance.post(`customer-envelope/document-upload`, data, config);
}

export function getEnvelopeDetail(data) {
    return axiosInstance.post(`envelope/detail`, data);
}

export function getManageEnvelopeList(data) {
    return axiosInstance.post(`envelope/list`, data);
}

export function sleeveFileDetailsForm(data) {
    return axiosInstance.post(`manage/sleeve-files/detail-form`, data)
}
export function sleeveFilePreviewDetailsForm(data) {
    return axiosInstance.post(`manage/sleeve-files/preview-detail-form`, data)
}

export function deleteManageEnvelope(data) {
    return axiosInstance.post(`envelope/delete`, data);
}

export function copyManageEnvelope(data) {
    return axiosInstance.post(`envelope/copy`, data);
}

export function uploadCustomerEnvelopeForm(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        }
    };
    return customerAxiosInstance.post(`customer-envelope/request-form`, data, config);
}

export function sendCustomerEnvelope(data) {
    return customerAxiosInstance.post(`customer-envelope/send`, data);
}

export function updateCustomerSignOnDocument(data) {
    return axiosInstance.post(`customer-envelope/sign-document-update`, data);
}

export function getCustomerSignDocumentPages(data) {
    return axiosInstance.post(`customer-envelope/sign-document-pages`, data);
}

export function declineCustomerSignDocument(data) {
    return axiosInstance.post(`customer-envelope/sign-document-decline`, data);
}


export function viewMangeEnvelope(data) {
    return axiosInstance.post(`envelope/manage`, data);
}

export function manageEnvelopeSetting(data) {
    return axiosInstance.post(`envelope/manage/setting`, data);
}

export function manageEnvelopeBulkMessage(data) {
    return axiosInstance.post(`envelope/manage/bulk-message`, data);
}

export function manageEnvelopeDocFormList(data) {
    return axiosInstance.post(`envelope/manage/doc-form-list`, data);
}

export function manageEnvelopeDocumentDetail(data) {
    return axiosInstance.post(`envelope/manage/doc-detail`, data);
}

export function manageEnvelopeSignDocumentDetail(data) {
    return axiosInstance.post(`envelope/manage/sign-doc-detail`, data);
}

export function manageEnvelopeDocFormStatusUpdate(data) {
    return axiosInstance.post(`envelope/manage/doc-form-status-update`, data);
}

export function userEnvelopeDownloadData(data) {
    return axiosInstance.post(`envelope/manage/download-recipient`, data);
}

export function userEnvelopeSpecificDownloadData(data) {
    return axiosInstance.post(`envelope/download-selected`, data);
}

export function manageEnvelopeFillFormDetail(data) {
    return axiosInstance.post(`envelope/manage/form-detail`, data);
}

export function manageEnvelopeClose(data) {
    return axiosInstance.post(`envelope/manage/close`, data);
}

export function manageEnvelopeResend(data) {
    return axiosInstance.post(`envelope/manage/resend`, data);
}

export function manageEnvelopeDocRules(data) {
    return axiosInstance.post(`envelope/manage/doc-rules`, data);
}


export function getNotificationAlert(data) {
    return axiosInstance.post(`notification-alert`, data);
}

export function readNotificationAlert(data) {
    return axiosInstance.post(`notification-read`, data);
}

export function getMessageAlert(data) {
    return axiosInstance.post(`message-alert`, data);
}

export function readMessageAlert(data) {
    return axiosInstance.post(`message-read`, data);
}

export function postNewsLetter(data) {
    return axiosInstance.post(`newsletter`, data);
}

export function postContact(data) {
    return axiosInstance.post(`contact`, data);
}

export function docFormTemplateUse(data) {
    return axiosInstance.post(`envelope/use-doc-form-template`, data);
}

export function envelopeHistory(data) {
    return axiosInstance.post(`envelope/history`, data);
}

export function getEnvelopeDataInAddRecipient(data) {
    return axiosInstance.post(`envelope/detail-for-add-recipient`, data);
}

export function addRecipientViewEnvelope(data) {
    return axiosInstance.post(`envelope/view-add-recipient`, data);
}

export function editRequestUpdateDocumentForm(data) {
    return axiosInstance.post(`envelope/view-edit-request-document-form`, data);
}

export function envelopeDownloadData(data) {
    return axiosInstance.post(`envelope/download-data`, data);
}

export function envelopeDownloadPdfData(envelopeId, recipientId) {
    return phpAxoisInstance.post(`envelope-data.php?envelope_id=` + envelopeId + `&recipient_id=` + recipientId);
}

export function envelopeDownloadAllFile(data) {
    return axiosInstance.post(`envelope/download-all-files`, data);
}

export function envelopeCustomerViewPortal(data) {
    return axiosInstance.post(`envelope/customer-view-detail`, data);
}

export function envelopeLeft(data) {
    return axiosInstance.post(`envelope/left`, data);
}

export function getPreferenceData(data) {
    return axiosInstance.post(`preferences`, data);
}

export function updatePreferenceData(data) {
    return axiosInstance.post(`preferences-update`, data);
}

export function docUploadClient(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        }
    };
    return axiosInstance.post(`envelope/doc-upload-view-doc`, data, config);
}

export function checkEnvelopeCredit(data) {
    return axiosInstance.post(`check-envelope-credit`, data);
}

export function checkEnvelopeStorage(data) {
    return axiosInstance.post(`/envelope/update-storage`, data);
}

export function postCareers(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        }
    };
    return axiosInstance.post(`career-form`, data, config);
}

export function postOneDriveConnect(data) {
    return axiosInstance.post(`one-drive-redirect`, data);
}

export function checkCloudIntegration(data) {
    return axiosInstance.post(`check-cloud-integration`, data);
}

export function postOneDriveDisconnect(data) {
    return axiosInstance.post(`one-drive-disconnect`, data);
}

export function docAdditionalFieldsUpdate(data) {
    return axiosInstance.post(`envelope/doc-additional-field-update`, data);
}

export function dataEnterUpdate(data) {
    return axiosInstance.post(`envelope/data-enter-update`, data);
}

export function removeDocUploadClient(data) {
    return axiosInstance.post(`envelope/remove-doc-upload`, data);
}

export function getCustomerPortalLink(data) {
    return axiosInstance.post(`envelope/customer-portal-link`, data);
}

export function uploadCompanyFile(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        },
    };
    return axiosInstance.post(`upload-company-image`, data, config);
}

export function removeCompanyImage(data) {
    return axiosInstance.post(`remove-company-image`, data);
}

export function uploadUserFile(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        },
    };
    return axiosInstance.post(`upload-user-image`, data, config);
}

export function removeUserImage(data) {
    return axiosInstance.post(`remove-user-image`, data);
}

export function transferEnvelopePost(data) {
    return axiosInstance.post(`envelope/transfer-envelope`, data);
}

export function checkTemplatePost(data) {
    return axiosInstance.post(`envelope/check-template`, data);
}

export function postDownloadFile(data) {
    return axiosInstance.post(`file-download`, data);
}

export function postGoogleDriveConnect(data) {
    return axiosInstance.post(`google-drive/connect`, data);
}

export function postGoogleDriveDisConnect(data) {
    return axiosInstance.post(`google-drive/disconnect`, data);
}

export function postGoogleCalendarConnect(data) {
    return axiosInstance.post(`google-calendar/connect`, data);
}

export function postGoogleCalendarDisConnect(data) {
    return axiosInstance.post(`google-calendar/disconnect`, data);
}

export function postGoogleCalendarBookingLink(data) {
    return axiosInstance.post(`google-calendar/booking-link`, data);
}

export function sendMailBookingLink(data) {
    return axiosInstance.post(`google-calendar/send-booking-link`, data);
}

export function getGoogleCalendarBookingLink(data) {
    return axiosInstance.post(`google-calendar/get-booking-link`, data);
}

export function postCloudList(data) {
    return axiosInstance.post(`cloud-list`, data);
}

export function postGenerateQrCode(data) {
    return axiosInstance.post(`generate-qr-code`, data);
}

export function postVerifyQrCode(data) {
    return axiosInstance.post(`verify-code`, data);
}

export function postRemoveQrCode(data) {
    return axiosInstance.post(`remove-authentication`, data);
}

export function documentUploadDrive(data) {
    return axiosInstance.post(`envelope/send-it-cloud`, data);
}

export function postDropBoxConnect(data) {
    return axiosInstance.post(`drop-box/auth-url`, data);
}

export function postDropBoxDisConnect(data) {
    return axiosInstance.post(`drop-box/disconnect`, data);
}

export function postBlogList(data) {
    return axiosInstance.post(`blog-list`, data);
}

export function postBlogDetail(data) {
    return axiosInstance.post(`blog-detail`, data);
}

export function envelopeVerifyOtp(data) {
    return axiosInstance.post(`customer-envelope/check-otp`, data);
}

export function postBoxConnect(data) {
    return axiosInstance.post(`box/auth-url`, data);
}

export function postBoxDisConnect(data) {
    return axiosInstance.post(`box/disconnect`, data);
}

export function getTemplateDocumentData(data) {
    return axiosInstance.post(`template/get-document-form`, data);
}

export function postUseTemplateDocumentData(data) {
    return axiosInstance.post(`envelope/use-document-data-template`, data);
}

export function informationQuestionUpdate(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        },
    };
    return axiosInstance.post(`envelope/information-question-update`, data, config);
}

export function postCustomerEnvelopeStopReminder(data) {
    return customerAxiosInstance.post(`customer-envelope/stop-reminder`, data);
}

export function getExpiredEnvelopeList() {
    return axiosInstance.post(`envelope/expired-list`);
}

export function getEnvelopeExpireDocuments(data) {
    return axiosInstance.post(`envelope/expired-documents`, data);
}

export function sendEnvelopeExpireDocuments(data) {
    return axiosInstance.post(`envelope/expired-documents/send`, data);
}

export function getCustomerDocumentExpired(data) {
    return axiosInstance.post(`customer-envelope/documents-expired`, data);
}

export function uploadCustomerEnvelopeDocumentExpired(data) {
    let config = {
        headers: {
            "content-type": "multipart/form-data",
        },
    };
    return customerAxiosInstance.post(`customer-envelope/document-expired-upload`, data, config);
}

export function moveEnvelopeFiles(data) {
    return axiosInstance.post('envelope/move-files', data);
}

export function copyEnvelopeToMyFiles(data) {
    return axiosInstance.post('envelope/copy-to-myfiles', data);
}

export function getEnvelopeFolderList(data) {
    return axiosInstance.post(`envelope/folder-list`, data);
}
export function calendarSync(data) {
    return axiosInstance.post(`envelope/calendar-sync`, data);
}

export function createSmartQuestionaire(data) {
    return axiosInstance.post(`sleeve/create-sleeve`, data);
}

export function createSmartQuestionaireForm(data) {
    return axiosInstance.post(`sleeve/create-form`, data);
}

export function getSmartQuestionaireDetails(data) {
    return axiosInstance.post(`sleeve/sleeve-detail`, data);
}

export function getSmartQuestionaireFormList(data) {
    return axiosInstance.post(`sleeve/form-list`, data);
}

export function sendSmartQuestionaire(data) {
    return axiosInstance.post(`sleeve/send-sleeve`, data);
}

export function editSmartQuestionaireForm(data) {
    return axiosInstance.post(`sleeve/edit-form`, data);
}

export function deleteSmartQuestionaireForm(data) {
    return axiosInstance.post(`/sleeve/delete-form`, data);
}

export function getSmartQuestionaireList(data) {
    return axiosInstance.post(`/sleeve/sleeve-list`, data);
}

export function deleteSmartQuestionaire(data) {
    return axiosInstance.post(`/sleeve/delete-sleeve`, data);
}

export function verifyCustomerSleeveOtp(data) {
    return axiosInstance.post(`customer-sleeve/verify-otp`, data);
}

export function getCustomerSleeveData(data) {
    return customerAxiosInstance.post(`customer-sleeve/details`, data);
}

export function submitCustomerSleeveAnswers(data) {
    return customerAxiosInstance.post(`customer-sleeve/submit`, data);
}

export function checkMyFilesEnabled(data) {
    return axiosInstance.post(`check-myfiles-enabled`, data);
}

export function getDashboardSleeveDetail(data) {
    return axiosInstance.post(`dashboard/sleeve-detail`, data);
}

export function getDashboardStatus(data) {
    return axiosInstance.post(`dashboard/status`, data);
}

export function getPaymentNotes(data) {
    return axiosInstance.post(`dashboard/note`, data);
}